<template>
    <div class="wrap">
        <head_index></head_index>
        <router-view></router-view>
        <footer_index></footer_index>
    </div>
</template>

<script>
    import footer_index from "../home/footer_index"
    import head_index from "./head_index"
    export default {
        name: "index",
        components:{
            head_index,
            footer_index
        }
    }
</script>

<style scoped>
    .wrap {
        min-height: 100%;
        display: flex;
        flex-direction: column;
    }
</style>
